import { render, staticRenderFns } from "./Alcohol.vue?vue&type=template&id=50cf5356&"
import script from "./Alcohol.vue?vue&type=script&lang=js&"
export * from "./Alcohol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports